import { createI18n, I18nOptions } from 'vue-i18n';

function getBrowserLocale(options = {}) {
  const defaultOptions = { countryCodeOnly: false };
  const opt = { ...defaultOptions, ...options };
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language;
  if (!navigatorLocale) {
    return undefined;
  }
  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim();
  return trimmedLocale;
}

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages: any = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([a-z0-9]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18nConfig: I18nOptions = {
  legacy: false,
  locale: getBrowserLocale({ countryCodeOnly: true }) || 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
};

const i18nVue = createI18n(i18nConfig);

export const translate = (key: string): string => {
  return (i18nVue.global as any).t(key);
};

export default i18nVue;
